export default __webpack_public_path__ + "static/media/44.34cd3b4c.png";